/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Calendar_Sync_TitleInputs */

const en_candidate_profile_calendar_sync_title = /** @type {(inputs: Candidate_Profile_Calendar_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar synchronization`)
};

const de_candidate_profile_calendar_sync_title = /** @type {(inputs: Candidate_Profile_Calendar_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalender-Synchronisation`)
};

/**
* | output |
* | --- |
* | "Calendar synchronization" |
*
* @param {Candidate_Profile_Calendar_Sync_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_calendar_sync_title = /** @type {((inputs?: Candidate_Profile_Calendar_Sync_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Calendar_Sync_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_calendar_sync_title(inputs)
	return en_candidate_profile_calendar_sync_title(inputs)
});